
import fbgg from "../../node_modules/common/src/components/alarm/fbgg";
import alarmNotice from "../../node_modules/common/src/components/alarm/alarmNotice";
import notice from "../../node_modules/common/src/components/alarm/notice";
import ascAnalyse from "../../node_modules/common/src/components/alarm/ascAnalyse";
import ascSelect from "@/components/alarm/ascSelect";
var data = [
  {
    path: "/asc/select",
    component: ascSelect
  }, {
    path: "/asc/analyse",
    component: ascAnalyse
  },
  {
    path: "/fbgg",
    component: fbgg
  }, 
  {
    path: "/alarmNotice",
    component: alarmNotice
  },
  {
    path: "/notice",
    component: notice
  },
  {
    path: "/base/group",
    component: () => import("@/pages/base/group/index")
  },
  {
    path: "/base/role",
    component: () => import("@/pages/base/role/index")
  },
  {
    path: "/base/user",
    component: () => import("@/pages/base/user/index")
  },
  {
    path: "/base/carType",
    component: () => import("@/pages/base/carType/index")
  },
  {
    path: "/base/car",
    component: () => import("@/pages/base/car/index")
  },
  {
    path: "/base/person",
    component: () => import("@/pages/base/person/index")
  },
  {
    path: "/base/driver",
    component: () => import("@/pages/base/driver/index")
  },
  {
    path: "/base/device",
    component: () => import("@/pages/base/device/index")
  },
  {
    path: "/log/login",
    component: () => import("@/pages/log/login/index")
  },
  {
    path: "/log/opt",
    component: () => import("@/pages/log/opt/index")
  },
  {
    path: "/msg/bulletin",
    component: () => import("@/pages/msg/bulletin/index")
  },
  {
    path: "/msg/notice",
    component: () => import("@/pages/msg/notice/index")
  },
  {
    path: "/msg/remind",
    component: () => import("@/pages/msg/remind/index")
  },
];
export default data;



// WEBPACK FOOTER //
// ./src/router/base.js